import { always, find, ifElse, isEmpty, join, pathOr, propEq, propOr } from 'ramda';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { useQuery } from '@apollo/client';
import { QGlobalDataQuery } from '@@app/graphql/index.js';
import extraAnalyticsData from '@@app/extra/extraAnalyticsData.js';

const useData = (middleFeatures) => {
  const analyticsEvents = propOr([], 'PROCESSDEVENTE_ANALYTICS_EVENTS', middleFeatures);

  const { context } = useProcess();

  const { data, loading } = useQuery(QGlobalDataQuery, {
    fetchPolicy: 'cache-and-network'
  });

  const getAnalyticsInformation = pathOr({}, ['getAnalyticsInformation', 'data'], data);
  const users = pathOr([], ['getUsersInformation', 'data'], data);
  const formatArray = ifElse((arr) => arr && !isEmpty(arr), join(' | '), always(''));

  const getEvent = (event) => find(propEq('event', event), analyticsEvents);

  const getCommonData = () => ({
    step: context.viewId,
    projectNumber: getAnalyticsInformation.projectNumber,
    selectedFormulas: formatArray(getAnalyticsInformation.selectedFormulas),
    monthlyPrices: formatArray(getAnalyticsInformation.monthlyPrices),
    yearlyPrices: formatArray(getAnalyticsInformation.yearlyPrices),
    signatureType: getAnalyticsInformation.signatureType,
    ...extraAnalyticsData(users, context)
  });
  return {
    getEvent,
    getCommonData,
    loading,
    getAnalyticsInformation,
    analyticsEvents,
    dataInit: extraAnalyticsData(users)
  };
};

export default useData;
